import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoSettingsOutline } from "react-icons/io5";

import { INCIDENT_TYPES } from "./incidentTypes";
import CreateIncidentModal from "../modals/CreateIncidentModal";

import { submitIncident } from "../../../features/incidents/incidentActions";

const IncidentSelection = ({ onClose }) => {
  const dispatch = useDispatch();

  const [selectedIncident, setSelectedIncident] = useState(null);

  const { loading, error, success } = useSelector((state) => state.incidents);

  const handleSubmit = async (formData) => {
    try {
      const result = await dispatch(submitIncident(formData)).unwrap();

      console.log("Incident submitted:", result);

      setSelectedIncident(null);
      onClose();
    } catch (error) {
      console.error("Incident submission failed:", error);

      // Do NOT close modal
      // User can see error and try again
    }
  };

  if (selectedIncident) {
    return (
      <CreateIncidentModal
        incidentType={selectedIncident}
        onClose={() => {
          setSelectedIncident(null);
        }}
        onSubmit={handleSubmit}
        loading={loading}
        error={error}
      />
    );
  }

  return (
    <div className="w-full bg-white font-sans">
      <div className="p-6 pb-4 flex justify-between items-start">
        <div>
          <h2 className="text-xl font-bold text-slate-800 tracking-tight">
            Incident Types
          </h2>

          <p className="text-sm text-slate-500 mt-1">
            Select a type to create a new incident
          </p>
        </div>

        <button
          onClick={onClose}
          className="text-slate-400 hover:text-slate-600 transition-colors text-xl p-1"
        >
          ✕
        </button>
      </div>

      <div className="px-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        {INCIDENT_TYPES.map((item) => {
          const IconComponent = item.icon;

          return (
            <button
              key={item.value}
              type="button"
              onClick={() => setSelectedIncident(item.value)}
              className="flex items-center gap-4 p-4 text-left border border-slate-100 rounded-xl hover:border-slate-300 hover:shadow-sm transition-all duration-200 group"
            >
              <div
                className={`
                  p-3 rounded-xl border flex-shrink-0
                  transition-transform
                  group-hover:scale-105
                  ${item.colors.icon}
                `}
              >
                <IconComponent className="text-2xl" />
              </div>

              <div>
                <h4 className="font-semibold text-slate-800 text-sm md:text-base">
                  {item.title}
                </h4>

                <p className="text-xs text-slate-400 mt-0.5">
                  {item.description}
                </p>
              </div>
            </button>
          );
        })}
      </div>

      <div className="mt-6 p-4 bg-slate-50 border-t border-slate-100">
        <button
          type="button"
          className="w-full flex items-center justify-center gap-2 py-2 text-sm font-semibold text-indigo-600"
        >
          <IoSettingsOutline className="text-lg" />
          Manage Incident Types
        </button>
      </div>
    </div>
  );
};

export default IncidentSelection;
